import CandleStickViz from '../vizs/CandleStickViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * 
 * Used to display price movements of a security, derivative, or currency. 
 * 
 * Each "candlestick" typically shows one day, thus a one-month chart may show the 20 trading days as 20 candlesticks. Candlestick charts can also be built using intervals shorter or longer than one day. It is similar to a bar chart in that each candlestick represents all four important pieces of information for that day: open and close in the thick body; high and low in the “candle wick”.
 * 
 * ### Example Usage
 * ```javascript
 *   import {CandleStick} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new CandleStick($el, data, config);
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 5 columns. Each row represents an entry, and the first column should be the X value, then its open,close, high and low values.
 *  
 * | X       |     Open  |    Close  |  High   |   Low    |
 * | -------- | ------ |-------|----------|-----------|
 * |   1      |    22.4|   22.4|  15.66  |   12.30    |
 * |   2      |    52.3|   12.5|   52.4 |   32.45    |
 * |   3      |    12.8|   52.2|  48.10  |   44.10    |
 * 
 * {.data-table}
 *
 */
export default class CandleStickComponent extends BaseComponent {
  static vizClass = CandleStickViz
  static dataFormat = [
    {index:0,axis:'x0',label:'id', types:[Number,Date],role:'id',roleLabel:'X value - Number or Date (dd-mm-yyyy)'},
    {index:1,axis:'y0', label:'Open', types:[Number],role:'value',roleLabel: 'Open'},
    {index:2,axis:'y0',label:'Close', types:[Number],role:'value',roleLabel: 'Close'},
    {index:3,axis:'y0',label:'High', types:[Number],role:'value',roleLabel: 'High'},
    {index:4,axis:'y0',label:'Low', types:[Number],role:'value',roleLabel: 'Low'}
  ]
  static componentLabel = "Candlestick"
  static defaultConfig = {
    title: this.componentLabel,
  }
}